import * as React from "react"
import { map as _map } from "lodash";
import { Tracker } from "../utils/Tracker";
import {EventNames} from "../utils/EventTrackerConstants";

export interface SuggestionTagsContainerProps {
    rootClass: string,
    suggestions: SuggestionItem[],
    inline?: boolean,
    index?: number,
    onTagSelect: (suggestionItem: SuggestionItem) => void
}

export interface SuggestionItem {
    speciality: string;
    recommendation: any;
    context: string;
    displayValue: string;
}

class SuggestionTagsContainer extends React.Component<SuggestionTagsContainerProps> {

    addValue = (suggestionItem: SuggestionItem) => {
        this.props.onTagSelect(suggestionItem);
        if (suggestionItem) {
            Tracker.track(EventNames.Suggestion + suggestionItem.context, {
                speciality: suggestionItem.speciality,
                displayValue: suggestionItem.displayValue,
                recommendation: JSON.stringify(suggestionItem.recommendation)
            })
        }
    }

    render() {
        const rootClass = this.props.rootClass ? `${this.props.rootClass}-suggestions-cont` : "";
        return (
            <div className={`suggestions-container ${rootClass}`}>
                <div className={"suggestions-label brandon-bold"}>Suggestions</div>
                {
                    _map((this.props.suggestions || []), (suggestion, index) => {
                        return <div key={`suggestion-${index}`} className={"suggestion-item"} onClick={() => this.addValue(suggestion)}>
                            {suggestion.displayValue}
                        </div>
                    })
                }
            </div>
        )
    }
}

export default SuggestionTagsContainer;